import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import './index.css';
import logo from './assets/spinner.gif'
import { performUserSignup } from "./functions";

function Signup() {
  console.log('Signup page load');

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch
  } = useForm();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [signuptext, setSignuptext] = useState('');
  const password = watch("password");

  const onSubmit = async (data) => {
    setLoading(true);
    setSignuptext("Creating account...");
    
    const result = await performUserSignup(data.email, data.password, data.bizcode);
    
    if (result.success) {
      setSignuptext("Account created successfully - redirecting");
      setTimeout(() => {
        console.log('Navigating to Home page');
        navigate('/');
      }, 2000);
    } else {
      setSignuptext(`**Signup Failed**: ${result.error}`);
      setLoading(false);
    }
  };

  return (
    <>
      <p className="title">Create Account</p>

      <form className="Login" onSubmit={handleSubmit(onSubmit)}>
        <input 
          type="email" 
          placeholder="Email Address"
          {...register("email", { 
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address"
            }
          })} 
        />
        
        <input 
          type="text" 
          placeholder="Business Code (e.g., ACME, TECH, etc.)"
          {...register("bizcode", { 
            required: "Business code is required",
            minLength: {
              value: 2,
              message: "Business code must be at least 2 characters"
            },
            maxLength: {
              value: 10,
              message: "Business code must be no more than 10 characters"
            },
            pattern: {
              value: /^[A-Za-z0-9]+$/,
              message: "Business code can only contain letters and numbers"
            }
          })} 
        />
        
        <input 
          type="password" 
          placeholder="Password"
          {...register("password", { 
            required: "Password is required",
            minLength: {
              value: 6,
              message: "Password must be at least 6 characters"
            }
          })} 
        />
        
        <input 
          type="password" 
          placeholder="Confirm Password"
          {...register("confirmPassword", { 
            required: "Please confirm your password",
            validate: value => value === password || "Passwords do not match"
          })} 
        />
        
        <input className="bg-brown" type="submit" value="Create Account" disabled={loading} />
      </form>
      
      <br />
      
      <div id="loginResponse">
        {loading ? (
          <>{signuptext}<br /><img src={logo} style={{ width: '50px' }} alt="loading..." /> </>
        ) : (
          <>
            {signuptext && <span className="loginSpan">{signuptext}</span>}
          </>
        )}
        
        {errors.email && <span className="loginSpan">{errors.email.message}</span>}
        {errors.bizcode && <span className="loginSpan">{errors.bizcode.message}</span>}
        {errors.password && <span className="loginSpan">{errors.password.message}</span>}
        {errors.confirmPassword && <span className="loginSpan">{errors.confirmPassword.message}</span>}
      </div>
      
      <br />
      <p>
        Already have an account? <Link to="/login">Login here</Link>
      </p>
    </>
  );
}

export default Signup;